import React from 'react';
import { EmissionContextProvider } from 'context/EmissionDataContext';

interface EmissionProviderProps {
  children: React.ReactNode;
}
const EmissionProvider: React.FC<EmissionProviderProps> = ({
  children,
}: EmissionProviderProps) => {
  return (
    <EmissionContextProvider>
      <div>{children}</div>
    </EmissionContextProvider>
  );
};

export default EmissionProvider;
